export function localDateStr(year, month, day) {
  const m = String(month).padStart(2, '0');
  const d = String(day).padStart(2, '0');
  return `${year}-${m}-${d}`;
}

export function getTodayStr() {
  const now = new Date();
  return localDateStr(now.getFullYear(), now.getMonth() + 1, now.getDate());
}
